module.exports = __webpack_public_path__ + "static/media/organization-default-logo.996f30fd.svg";